import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import moment from 'moment-timezone';
import { isEmpty as _isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import RoundTitle from '@atoms/RoundTitle';
import FloatBoardArea from '@molecules/FloatBoardArea';
import { GFH_ENV, isMobileWithOutIpad } from '@helpers/EnvHelper';
import MobileBoardArea from '@molecules/contents/MobileBoardArea';
import { useLocation, useNavigate } from 'react-router-dom';

const BoardDetail = ({ idx, data }) => {
  const { t } = useTranslation();
  const type = data?.boardName == 'notice' ? 'news' : 'event';
  const location = useLocation();
  const navigate = useNavigate();
  const isLink = location.pathname.includes('link');

  useEffect(() => {}, []);

  return (
    <>
      <section className=" mb-[120px]">
        <div className="text-center">
          <RoundTitle title={t(data?.boardName)} />
          <p className="text-[#989898] py-5 text-xl ">
            {data[`${i18n.language === 'kr' ? 'ko' : i18n.language}Category`]}
          </p>
        </div>

        <div className="max-w-[720px] lg:max-w-[1200px] m-auto overflow-hidden ">
          <div className={classnames('mb-[40px]', 'xl:mb-[80px]')}>
            <h1
              className="text-center border-y border-[#e2e2e2] px-5 py-[15px] md:py-[30px] text-2xl font-bold "
              style={{ wordBreak: 'break-all' }}
            >
              {data?.title}
            </h1>
          </div>
          <div className="text-right text-[#b0b0b0] pr-4">
            <time>{moment(`${data.startDt}`).format('YYYY.MM.DD')}</time>
          </div>
          <div className="p-5 md:p-0 min-h-[800px] landscape:!pb-[100px]">
            {!_isEmpty(data) && (
              <article
                className="p-1 pb-10  prose prose-sm lg:prose-2xl max-w-none font-light editor_style_wrap"
                style={{ wordBreak: 'break-all' }}
                dangerouslySetInnerHTML={{
                  __html: data?.mainContent,
                }}
              ></article>
            )}
          </div>
        </div>

        {!isMobileWithOutIpad() && (
          <FloatBoardArea
            link={`/${i18n.language}${isLink ? '/link' : ''}/community/${type}`}
          />
        )}

        {isMobileWithOutIpad() && (
          <MobileBoardArea
            link={`/${i18n.language}${isLink ? '/link' : ''}/community/${type}`}
          />
        )}
      </section>
    </>
  );
};

export default observer(BoardDetail);
